/**
 * @generated SignedSource<<6ad74deee7087cf7ea03dc55bc00d1f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetSubscriptionAmountOverrideInput = {
  id: string;
  monthlyNetAmount: number;
  note?: string | null | undefined;
};
export type EditSubscriptionAmountOverrideDialogMutation$variables = {
  input: SetSubscriptionAmountOverrideInput;
};
export type EditSubscriptionAmountOverrideDialogMutation$data = {
  readonly setSubscriptionAmountOverride: {
    readonly id: string;
    readonly monthlyNetAmount: number;
    readonly note: string | null | undefined;
    readonly setAt: any;
    readonly setBy: string;
  };
};
export type EditSubscriptionAmountOverrideDialogMutation = {
  response: EditSubscriptionAmountOverrideDialogMutation$data;
  variables: EditSubscriptionAmountOverrideDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubscriptionAmountOverride",
    "kind": "LinkedField",
    "name": "setSubscriptionAmountOverride",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "monthlyNetAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "note",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSubscriptionAmountOverrideDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditSubscriptionAmountOverrideDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f28b94e25a79a322afc6e979524465b8",
    "id": null,
    "metadata": {},
    "name": "EditSubscriptionAmountOverrideDialogMutation",
    "operationKind": "mutation",
    "text": "mutation EditSubscriptionAmountOverrideDialogMutation(\n  $input: SetSubscriptionAmountOverrideInput!\n) {\n  setSubscriptionAmountOverride(input: $input) {\n    id\n    monthlyNetAmount\n    note\n    setBy\n    setAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e61343f692cc9a2b44d58ad75611a67";

export default node;
